import axios from "@/libs/axios";
import { getUserData } from "@/auth/getUserData";

export default function useEvents() {
    const saveEvent = (event: { name: string; target?: unknown; payload?: unknown; actor?: unknown }) => {
        if (!event.actor) {
            const user = getUserData();
            event.actor = {
                reference: user.id,
                entityType: "user",
                actorFullName: user.name,
            };
        }
        // We need a default for target even if the event has no target. Id 0 isn't in use, so it's a safe reference
        if (!event.target) {
            event.target = {
                reference: 0,
            };
        }
        return axios.post("events", event);
    };

    return {
        saveEvent,
    };
}
